// src/api/cases/getAllCommentsByCaseId.ts
//
// Fetches ALL comments for a case (up to 5000).
// Does NOT modify existing getCommentsByCaseId.ts (which stays at Take:100).

import axiosInstance from 'api/axiosInstance';
import { CANtrackCommentRaw } from 'api/comments/getComments';

export const getAllCommentsByCaseId = async (
	caseId: number,
): Promise<CANtrackCommentRaw[]> => {
	try {
		const payload = { CaseId: caseId, Take: 5000, Page: 1 };
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/ReadComments?payload=${JSON.stringify(payload)}`,
		);
		return data?.Data ?? [];
	} catch (error) {
		console.error('[getAllCommentsByCaseId] Failed for case:', caseId, error);
		throw error;
	}
};
